<template>
    <button
      class="el-button"
      @click="handleClick"
      :disabled="buttonDisabled || loading"
      :autofocus="autofocus"
      :type="nativeType"
      :class="[
        type ? 'el-button--' + type : '',
        buttonSize ? 'el-button--' + buttonSize : '',
        {
          'is-disabled': buttonDisabled,
          'is-loading': loading,
          'is-plain': plain,
          'is-round': round,
          'is-circle': circle
        }
      ]"
    >
      <i class="el-icon-loading" v-if="loading"></i>
      <i :class="icon" v-if="icon && !loading"></i>
      <span v-if="defaultData">{{defaultData}}</span>
    </button>
</template>
<script>
    import { Button } from 'element-ui'
    import { productConfigDrawer } from '@/views/marketingManagement/honor/modal/index.js'
    import { showErrorTip } from '@/utils'
    export default {
        name: 'WkHonorProductConfig',
        extends: Button,
        props: {
            rootFormData: {
              type: Object,
              default: () => {}
            },
            rootFormDataOptions: {
              type: Object,
              default: () => {}
            },
            defaultData: {
                type: String,
                default: '按钮'
            },
            value:{}
        },
        methods: {
            
            handleClick() {
              if(!this.rootFormDataOptions?.app_id || this.rootFormDataOptions?.app_id?.length == 0){
                  return this.$message.warning('请选择产品。')
              }
              if(_.isEmpty(this.rootFormData.promotion_purpose)){
                showErrorTip(
                    {
                        selectors: ['promotion_purpose', 'product_type'],
                        errorText: '产品配置与推广目标、推广方式有关联，请先选择推广目标、推广方式。'
                    }
                );
                return
              }
              if(_.isEmpty(this.rootFormData.ad_placement_id)){
                showErrorTip(
                    {
                        selectors: ['ad_placement_id']
                    }
                );
                return this.$message.warning('请选择版位。')
              }
              const {vm} = productConfigDrawer({
                props: {
                  rootFormData: this.rootFormData,
                  rootFormDataOptions: this.rootFormDataOptions,
                  value:this.value,
                },
                cbs: {
                  onSubmit: (res) => {
                      console.log('结果',res)
                      this.$emit('input', res)
                      let ele = document.getElementById('ads_clear')
                      ele.dataset.field = ['product_config_list']
                      if(ele){
                        ele.click()
                      }
                      vm.close()
                  }
                }
              })
            }
        },
        watch: {
            'rootFormData.app_id': {
                handler(newVal, oldVal) {
                  if(_.isEqual(newVal, oldVal)) {
                    return;
                  }
                   this.$emit('input', (this.value || []).filter(v=> (newVal || []).includes(v.app_id)))
                },
            }
        }
    }
</script>